<template>
  <b-modal :visible="visible" @hide="$emit('close')" title="Детали предикта" size="lg">
    <div v-if="prediction">
      <div class="row mb-3">
        <div class="col-md-6"><strong>ID:</strong> {{ prediction.id }}</div>
        <div class="col-md-6"><strong>Статус:</strong>
          <b-badge :variant="statusVariant">{{ statusLabel }}</b-badge>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6"><strong>Название:</strong> {{ prediction.name || '—' }}</div>
        <div class="col-md-6"><strong>Описание:</strong> {{ prediction.description || '—' }}</div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6"><strong>Призовой фонд:</strong> {{ prediction.prize_fund || '—' }}</div>
        <div class="col-md-6"><strong>Длительность:</strong> {{ prediction.duration_minutes ? prediction.duration_minutes + ' мин' : '—' }}</div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4"><strong>Турнир:</strong> {{ prediction.tournament_name || prediction.tournament?.name || '—' }}</div>
        <div class="col-md-4"><strong>Стадия:</strong> {{ prediction.stage_name || prediction.stage?.name || '—' }}</div>
        <div class="col-md-4"><strong>Группа:</strong> {{ prediction.group_name || prediction.group?.name || '—' }}</div>
      </div>

      <h6 class="mt-4 mb-3">Результаты</h6>
      <p><strong>Всего голосов:</strong> {{ prediction?.total_votes || '-' }}</p>
      <b-table
        v-if="teams.length"
        striped
        hover
        :items="teams"
        :fields="teamFields"
        small
      >
        <template #cell(name)="data">
          {{ data.item.name || `Команда #${data.item.id}` }}
        </template>
        <template #cell(votes_count)="data">
          {{ data.item.vote_count || 0 }}
        </template>
        <template #cell(percentage)="data">
          {{ calculatePercentage(data.item.vote_count) }}%
        </template>
      </b-table>
      <p v-else class="text-muted">Нет команд</p>
    </div>

    <template #modal-footer>
      <b-button
        v-if="prediction && prediction.status === 'published'"
        variant="warning"
        @click="$emit('close-prediction')"
      >
        <i class="fa fa-stop mr-1"></i> Закрыть приём
      </b-button>
      <b-button
        v-if="prediction && prediction.status === 'closed'"
        variant="info"
        @click="$emit('resolve-prediction')"
      >
        <i class="fa fa-check mr-1"></i> Подвести итоги
      </b-button>
    </template>
  </b-modal>
</template>

<script>
const STATUS_VARIANTS = { draft: 'secondary', published: 'success', closed: 'warning', resolved: 'info' };
const STATUS_LABELS = { draft: 'Черновик', published: 'Активен', closed: 'Закрыт', resolved: 'Завершён' };

export default {
  name: "PredictionDetailModal",
  props: {
    visible: { type: Boolean, default: false },
    prediction: { type: Object, default: null },
    teams: { type: Array, default: () => [] },
  },
  data() {
    return {
      teamFields: [
        { key: 'name', label: 'Команда' },
        { key: 'votes_count', label: 'Количество голосов' },
        { key: 'percentage', label: 'Процент' },
        { key: 'progress', label: '' },
      ],
    }
  },
  computed: {
    statusVariant() {
      return STATUS_VARIANTS[this.prediction?.status] || 'secondary';
    },
    statusLabel() {
      return STATUS_LABELS[this.prediction?.status] || this.prediction?.status;
    },
    totalVotes() {
      return this.teams.reduce((sum, t) => sum + (t.vote_count || 0), 0);
    },
  },
  methods: {
    calculatePercentage(votes) {
      if (!this.totalVotes) return 0;
      return ((votes / this.totalVotes) * 100).toFixed(2);
    },
  }
}
</script>
